import { Component, AfterContentInit, ChangeDetectorRef } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { OffcanvasOptions } from '../../../../core/_base/layout';
import { AuthServiceCustom } from 'src/app/core/auth/authServiceCustom';
import { OAuthService } from 'angular-oauth2-oidc';
import { SessionBusiness } from 'src/app/core/_config/sessionBusiness.service';
import { NotificationsService } from 'angular2-notifications';

@Component({
    selector: 'kt-quick-user-panel',
    templateUrl: './quick-user-panel.component.html',
    styleUrls: ['./quick-user-panel.component.scss'],
})
export class QuickUserPanelComponent implements AfterContentInit {
    // Public properties
    offcanvasOptions: OffcanvasOptions = {
        overlay: true,
        baseClass: 'offcanvas',
        placement: 'right',
        closeBy: 'kt_quick_user_close',
        toggleBy: 'kt_quick_user_toggle',
    };

    constructor(
        private authServiceCustom: AuthServiceCustom,
        private oauthService: OAuthService,
        private cdRef: ChangeDetectorRef,
        private sessionBusiness: SessionBusiness,
        private notificationsService: NotificationsService,
    ) {}

    completeName: string;
    imgUser: string;
    email: string;
    entityDescription: string;

    ngAfterContentInit(): void {
        this.oauthInformation();
        this.findSessionContext();
        this.cdRef.detectChanges();
    }

    private oauthInformation(): void {
        this.completeName = this.authServiceCustom.completeName;
        this.imgUser = `url(${this.authServiceCustom.urlImg})`;
        this.email = this.authServiceCustom.userEmail;
    }

    findSessionContext(): void {
        if (this.sessionBusiness.EntityDescriptionContext === 'NotFound') {
            this.notificationsService.error('Atenção', 'Entidade não encontrada');
        } else {
            this.entityDescription = this.sessionBusiness.EntityDescriptionContext;
        }
    }

    logout() {
        var expire_date = new Date();
        expire_date.setDate(expire_date.getDate() - 1);
        document.cookie = 'ContextSelected=; expires=' + expire_date.toUTCString();

        this.oauthService.logOut(false);
    }
}
